// extracted by mini-css-extract-plugin
export default {"invalidInput":"ErrorLabel_invalidInput__ZFHJV","yellowLabel":"ErrorLabel_yellowLabel__wFien","greenLabel":"ErrorLabel_greenLabel__9yR1a"};